import { DriveTrain } from '~/graphql/mapper';

export type DriveTrainModelId = DriveTrain['modelId'];

export const getCorrectDriveTrain = (driveTrains: DriveTrain[], modelId: DriveTrainModelId) => {
	return driveTrains.find((d) => JSON.stringify(d.modelId) === JSON.stringify(modelId));
};
